import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
var _effectorFileName = "/builds/gmini/front-api-call-service/src/Jsend.ts";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.number.constructor.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as t from 'io-ts';
import { fold } from 'fp-ts/lib/Either';
export var isJsendResultError = function isJsendResultError(result) {
  return result.status === 'error';
};
export var isJsendBadResultError = function isJsendBadResultError(result) {
  return result.status === 'error';
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var JsendResultError = t.intersection([t.type({
  status: t.literal('error'),
  message: t.string
}), t.partial({
  code: t.number
})]);
export var isIOTSErrorResult = function isIOTSErrorResult(result) {
  return result.status === 'io-ts error';
};
export var isJsendResultFail = function isJsendResultFail(result) {
  return result.status === 'fail';
};
export var isJsendBadResultFail = function isJsendBadResultFail(result) {
  return result.status === 'fail';
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var JsendResultFail = t.recursion('JsendResponseFail', function () {
  return t.type({
    status: t.literal('fail'),
    data: JsendResultFailData
  });
});
export var JsendResultFailData = t.recursion('JsendResultFailData', function () {
  return t.type({
    errorCode: t.string,
    failReason: t.string
  });
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var JsendBadResult = t.union([JsendResultFail, JsendResultError]);
export function createJsendResult(type) {
  return t.union([createJsendSuccessResult(type), JsendBadResult]);
}
export var isJsendSuccessResult = function isJsendSuccessResult(result) {
  return result.status === 'success';
};
export function createJsendSuccessResult(type) {
  return t.type({
    status: t.literal('success'),
    data: type
  });
}
export function createJsendResponseValidator(type, validationOff) {
  var Result = validationOff ? t.unknown : createJsendResult(type);

  function validate(left, right) {
    return function (value) {
      var result = Result.decode(value.data);
      return fold(function (errors) {
        return left({
          status: 'io-ts error',
          errors: decode(errors),
          value: value,
          res: value
        });
      }, function (result) {
        return result.status === 'success' ? right(result.data) : left(_objectSpread(_objectSpread({}, result), {}, {
          res: value
        }));
      })(result);
    };
  }

  var toPromise = validate(function (badResult) {
    return Promise.reject(badResult);
  }, function (value) {
    return Promise.resolve(value);
  });
  return {
    validate: validate,
    toPromise: toPromise
  };
}
export function decode(errors) {
  var error = errors[0];
  var actualErr = error.context[error.context.length - 1];
  var errPath = error.context.map(function (c) {
    return c.key;
  }).filter(function (key) {
    return key.length > 0;
  }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var typeOf = function typeOf(typedValue) {
    return Array.isArray(typedValue) ? 'array' : _typeof(typedValue);
  };

  return "Expected ".concat(actualErr.type.name, ", but got ").concat( // eslint-disable-next-line no-undefined
  error.value === undefined ? 'undefined' : JSON.stringify(error.value), " (").concat(typeOf(error.value), ") , ").concat(['PATH:'].concat(_toConsumableArray(errPath)).filter(function (string) {
    return isNaN(Number(string));
  }).join(':'));
}